import { Box, Heading, Text } from '@chakra-ui/react'
import Header from '../Header'
import PageTransition from '../components/PageTransition'

const Fun = (): JSX.Element => (
  <>
    <Header title="Fun" subtitle="Enjoy some light-hearted content" />
    <PageTransition>
      <Box p={4}>
        <Heading as="h2" size="xl" mb={4}>Fun and Games</Heading>
        <Text fontSize="md">This page will feature fun and engaging content related to investments and finance.</Text>
      </Box>
    </PageTransition>
  </>
)

export default Fun
